import React from 'react';
import useInView from '../hooks/useInView';
import useCounter from '../hooks/useCounter';

const STATS = [
    { end: 12,  suffix: '+', label: 'Years of Excellence' },
    { end: 250, suffix: '+', label: 'Clients Served' },
    { end: 500, suffix: '+', label: 'Projects Delivered' },
    { end: 35,  suffix: '+', label: 'Expert Consultants' },
];

function StatItem({ end, suffix, label }) {
    const [ref, inView] = useInView();
    const count = useCounter(end, 2200, inView);

    return (
        <div className="stat-item fade-up" ref={ref}>
            <div className="stat-number">{count}{suffix}</div>
            <div className="stat-label">{label}</div>
        </div>
    );
}

function Stats() {
    return (
        <section className="stats">
            <div className="stats-grid">
                {STATS.map((s, i) => (
                    <StatItem key={i} {...s} />
                ))}
            </div>
        </section>
    );
}

export default Stats;
